import { App as AntdApp, ConfigProvider } from 'antd';
import ruRU from 'antd/locale/ru_RU';
import { RouterProvider } from 'react-router-dom';

import ErrorBoundary from '@/components/ErrorBoundary';
import { router } from '@/routes';
import { BarrierWorkspaceProvider } from '@/stores/BarrierWorkspaceContext';
import { IndustrialFocusProvider } from '@/stores/IndustrialFocusContext';
import { MapLayersProvider } from '@/stores/MapLayersContext';
import { MapToolProvider } from '@/stores/MapToolContext';
import { RecomputeProgressProvider } from '@/stores/RecomputeProgressContext';
import { RouteWorkspaceProvider } from '@/stores/RouteWorkspaceContext';
import { TileRevisionProvider } from '@/stores/TileRevisionContext';

const THEME = {
  token: {
    colorPrimary: '#389e0d',
    colorSuccess: '#52c41a',
    colorWarning: '#d4a017',
    colorInfo: '#1677ff',
    borderRadius: 6,
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
};

export default function App() {
  return (
    <ConfigProvider locale={ruRU} theme={THEME}>
      <AntdApp>
        <ErrorBoundary>
          <MapToolProvider>
            <MapLayersProvider>
              <BarrierWorkspaceProvider>
                <RouteWorkspaceProvider>
                  <TileRevisionProvider>
                    <RecomputeProgressProvider>
                      <IndustrialFocusProvider>
                        <RouterProvider router={router} />
                      </IndustrialFocusProvider>
                    </RecomputeProgressProvider>
                  </TileRevisionProvider>
                </RouteWorkspaceProvider>
              </BarrierWorkspaceProvider>
            </MapLayersProvider>
          </MapToolProvider>
        </ErrorBoundary>
      </AntdApp>
    </ConfigProvider>
  );
}
